<web-design-system-modal [headline]="'depot.dividend-received-modal.headline' | transloco" (dismiss)="modal.dismiss()">
  <p class="zero-text p-base-reg">{{ 'depot.dividend-received-modal.text' | transloco }}</p>
  <p class="zero-text p-base-reg" [innerHTML]="'depot.dividend-received-modal.link' | transloco"></p>
  <div class="zero-surface grey-800 p-3">
    <web-design-system-checkbox [isChecked]="false" (isCheckedChange)="isCheckboxChecked = $event">
      <span class="zero-text p-big-med" [innerHTML]="'my-home.my-home-page.dividend-re-invest-hint.checkbox' | transloco"> </span>
    </web-design-system-checkbox>
  </div>
  <div class="mt-4 d-flex flex-column flex-xl-row justify-content-xl-end align-items-center gap">
    <a
      class="zero-text cursor-pointer p-base-reg link-secondary no-select"
      [class.disabled]="facade.hasOngoingRequest$ | async"
      (click)="decline()"
    >
      {{ 'depot.dividend-received-modal.actions.no' | transloco }}
    </a>
    <web-design-system-button
      type="secondary"
      size="small"
      [disabled]="(facade.hasOngoingRequest$ | async) || !isCheckboxChecked"
      (click)="activate(25)"
    >
      {{ 'depot.dividend-received-modal.actions.yes' | transloco: { value: 25 } }}
    </web-design-system-button>
    <web-design-system-button
      type="primary"
      size="small"
      [disabled]="(facade.hasOngoingRequest$ | async) || !isCheckboxChecked"
      (click)="activate(1)"
    >
      {{ 'depot.dividend-received-modal.actions.yes' | transloco: { value: 1 } }}
    </web-design-system-button>
  </div>
</web-design-system-modal>
